<template>
    <section id="map-campaign">
    <Header 
    :header_page_data="headerPageData"
    ></Header>
    <SearchCampaignMapModal>
        :searchParameters="searchParameters"
    </SearchCampaignMapModal>
    <div class="row ml-0 mr-0">
        <div v-if="$store.getters['online']" class="col-12 pr-0 pl-0">
            <gmap-autocomplete
                :options="{
                    fields: ['geometry.location', 'formatted_address'],
                }"
                ref="autocomplete"
                @place_changed="setPlace"
                :placeholder="$t('campaign_map.search')"
                :select-first-on-enter="true"
                @input="googleAutocompleteChange"
            >
            </gmap-autocomplete>
            <button v-if="showIcs" class="btn btn-light google-clear-button" @click="clearPlaceInput"><img src="./../../assets/ics_search.svg" alt="search" /></button>
        </div>
    </div>
      <section class="campaign-container">
        <div class="container container-app">
            <section v-if="$store.getters['online']" class="position-relative campaigns-container">
                <gmap-map
                    @zoom_changed="zoomChanged"
                    @dragend="dragendMap"
                    ref="campaignMap"
                    :options="mapOptions"
                    :center="tmpMarker"
                    :zoom=17
                    style="position: fixed;left: 0px;width: 100%;height: 100%;"
                    map-type-id="roadmap"
                >
                    <gmap-info-window :options="infoOptions" :position="infoPosition" :opened="infoOpened" @closeclick="infoOpened=false">
                        <div class="info-window" v-html="infoContent"></div>
                    </gmap-info-window>
                    <GmapCluster
                        ref="gamapcluster"
                        :maxZoom=17
                        :styles="clusterStyles"  
                    >
                        <gmap-marker v-for="(item, key) in markers" 
                            :key="key" 
                            :position="getPosition(item)" 
                            :clickable="true" 
                            @click="goToEdit(item, key)" 
                            :icon="{labelOrigin: {x: 21, y: 18},  url: item.respondents_count > 1 ? require('./../../assets/group_pin.svg') : require('./../../assets/marker.svg')}"
                            :label="item.respondents_count > 1 ? String(item.respondents_count) : ''"
                        />
                    </GmapCluster>
                    <gmap-marker 
                        key="tmpMarker" 
                        :position="getPosition(tmpMarker)" 
                        :clickable="false"
                        :draggable="true"
                        :zIndex="9999"
                        @dragend="dragMarker($event)"
                        :icon="{ url: require('./../../assets/marker_green.svg')}"
                    />
                </gmap-map>
            </section>
            <section v-else>
                <div class="position-relative campaigns-container offline-map-container">
                    <div class="add-marker-offline">
                        <img @click.prevent="addLocation()" src="./../../assets/marker_green.svg" alt="marker">
                    </div>
                    <div class="text-center">
                        <label class="offline-label-marker">
                            {{ $t('campaign_map.offline_label') }}
                        </label>
                    </div>
                </div>
            </section>
        </div>
        <div v-if="$store.getters['online']">
            <div v-if="showRestrictedFilter" class="blocked-search-text">
                {{ $t('campaign_map.restricted_campaign_filter_text') }}
                <button @click.prevent="toggleFilterRestrictedInfo()" style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%; display: block; border: 0px none; margin: 0px; padding: 0px; position: absolute; cursor: pointer; user-select: none; top: -6px; right: -6px; width: 30px; height: 30px;" draggable="false" title="Close" aria-label="Close" type="button" class="gm-ui-hover-effect"><img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23000000%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M19%206.41L17.59%205%2012%2010.59%206.41%205%205%206.41%2010.59%2012%205%2017.59%206.41%2019%2012%2013.41%2017.59%2019%2019%2017.59%2013.41%2012z%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22%2F%3E%0A%3C%2Fsvg%3E%0A" style="pointer-events: none; display: block; width: 14px; height: 14px; margin: 8px;"></button>
            </div>
            <div v-if="extendedAddPin" class="add-marker-extended">
                <img @click.prevent="addLocation()" src="./../../assets/add_to_map.svg" alt="marker">
            </div>
            <div v-else class="add-marker">
                <img @click.prevent="addLocation()" src="./../../assets/add_marker.svg" alt="marker">
            </div>
            <div class="center-location">
                <img class="geolocate" @click.prevent="geolocate(true)" src="./../../assets/loc_big.svg" alt="loc_big">
            </div>
            <div v-if="!isFilter && isOwner($store.getters['currentCampaign'].owner_id)" class="search-map">
                <img @click.prevent="showSearch()" src="./../../assets/search_map.svg" alt="search_map">
            </div>
            <div v-else-if="isOwner($store.getters['currentCampaign'].owner_id)" class="search-map-applied">
                <img @click.prevent="showSearch()" src="./../../assets/filter_applied.svg" alt="search_map">
            </div>
            <div v-else class="search-map">
                <img @click.prevent="toggleFilterRestrictedInfo()" src="./../../assets/search_map_grey.svg" alt="search_map">
            </div>
        </div>
      </section>
    <CampaignFooter></CampaignFooter>
    </section>
</template>

<script>
    import Vue from "vue";
    import Header from "../layouts/Header";
    import CampaignFooter from "../layouts/CampaignFooter";
    import HelperMixin from "../../mixins/HelperMixin";
    import { gmapApi } from 'vue2-google-maps';
    import GmapCluster from 'vue2-google-maps/dist/components/cluster';
    import SearchCampaignMapModal from "../modals/SearchCampaignMapModal";

    Vue.component('GmapCluster', GmapCluster)

    export default {
        name: "CampaignMap",
        components: {Header, CampaignFooter, SearchCampaignMapModal},
        mixins: [HelperMixin],
        props:['campaign'],
        data() {
            return {
                showRestrictedFilter: false,
                firstTooltipContent: '<div class="w-100 text-center"><b>' + this.$t('campaign_map.tooltip_message') + '</b></div>',
                extendedAddPin: false,
                showIcs: false,
                clusterStyles: [
                        {
                        textColor: "black",
                        url: require('./../../assets/group_pin.svg'),
                        height: 50,
                        width: 50,
                        textSize: 17,
                        anchorText: [-7, -4],
                        fontWeight: 100
                        }
                ],
                isFilter: false,
                searchParameters: {
                    answers: {},
                    reception: 0
                },
                page: null,
                bounds: {},
                rememberBounds: null,
                giveRememberBounds: false,
                tmpMarker: {
                    full_address: typeof this.$store.getters["currentCampaign"].location != 'undefined' ? this.$store.getters["currentCampaign"].location.properties.full_address : 'Montreal',
                    lat: typeof this.$store.getters["currentCampaign"].location != 'undefined' ? this.$store.getters["currentCampaign"].location.geometry.coordinates[1] : 45.508,
                    lng: typeof this.$store.getters["currentCampaign"].location != 'undefined' ? this.$store.getters["currentCampaign"].location.geometry.coordinates[0] : -73.508,
                },
                markers: [],
                infoPosition: null,
                infoContent: null,
                infoOpened: false,
                infoCurrentKey: null,
                infoOptions: {
                    pixelOffset: {
                        width: 0,
                        height: -55
                    }
                },
                mapOptions: {
                    styles: [
                        {
                            featureType: 'poi.business',
                            elementType: 'labels',
                            stylers: [
                                { visibility: 'off' }
                            ]
                        }
                    ],
                    clickableIcons: false,
                    disableDefaultUI: true,
                    minZoom: 6, 
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    disableDefaultUi: false,
                    autobindAllEvents: true
                },
                headerPageData: {
                    title: this.$store.getters["currentCampaign"].name,
                    search: {
                        show: false,
                        type_search: ''
                    },
                    settings: {
                        show: true,
                        campaign: this.$store.getters["currentCampaign"]
                    },
                    home: {
                        show: true,
                    },
                    profile: {
                        show: false
                    }
                }
            }
        },
        created() {
            this.refreshData();
        },
        computed: {
            google: gmapApi,
        },
        mounted() {
            if (this.$store.getters["online"]) {
                $('.campaign-container').css("background-color", "");
            } else {
                $('.campaign-container').css("background-color", "#f0f0f0");
            }
        },
        methods: {
            dragendMap() {
                var evt = this.$refs.campaignMap.$mapObject.getBounds();
                var northEast = evt.getNorthEast();
                var southWest = evt.getSouthWest();
                if ( 
                    typeof evt != 'undefined' &&
                    (
                        this.bounds.south != southWest.lat() ||
                        this.bounds.north != northEast.lat() ||
                        this.bounds.west != southWest.lng() ||
                        this.bounds.east != northEast.lng()
                    )
                ) { 
                    this.page = null;
                    this.bounds.south = southWest.lat();
                    this.bounds.north = northEast.lat();
                    this.bounds.west = southWest.lng();
                    this.bounds.east = northEast.lng();
                    this.giveRememberBounds = true;
                    this.getMarkersLocations();
                    
                }
            },

            toggleFilterRestrictedInfo() {
                this.showRestrictedFilter = !this.showRestrictedFilter;
            },

            googleAutocompleteChange() {
                if (this.$refs.autocomplete.$el.value != '') {
                    this.showIcs = true;
                } else {
                    this.showIcs = false;
                }
            },

            mapAnswersModelsFilter() {
                if (typeof this.$store.getters["currentCampaign"].questions != 'undefined') {
                    for (var i = 0; i < this.$store.getters["currentCampaign"].questions.length; i++) {
                        if (this.$store.getters["currentCampaign"].questions[i].is_visible == true) {
                            if ( this.$store.getters["currentCampaign"].questions[i].type == 'single') {
                                this.searchParameters.answers[this.$store.getters["currentCampaign"].questions[i]._id] = ''; 
                            } else {
                                this.searchParameters.answers[this.$store.getters["currentCampaign"].questions[i]._id] = [];
                            }
                        }
                    }
                }
            },

            showSearch() {
                $('#searchCampaignMapModal').modal('show');
            },

            getMarkersLocations() {
                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                
                let sendData = {};
                sendData.boundaries = this.bounds;
                if (this.giveRememberBounds) {
                    sendData.previous_viewport = this.rememberBounds;
                }
                if (this.page) {
                    sendData.page = this.page;
                }
                if (this.searchParameters.reception != 0) {
                    sendData.reception = this.searchParameters.reception;
                }
                let combinedArray = [];
                for (const property in this.searchParameters.answers) {
                    if(typeof this.searchParameters.answers[property] === 'string') {
                        if (this.searchParameters.answers[property].length > 0) {
                            combinedArray.push(this.searchParameters.answers[property]);
                        }
                    } else {
                         combinedArray.push(...this.searchParameters.answers[property]);
                    }
                }
                
                if (combinedArray.length > 0) {
                    sendData.answers = combinedArray;
                }
                
                axios.post(
                        '/api/v1/campaign/' +  this.$route.params.campaign_id + '/location/map',
                        sendData,
                        config
                ).then(this.consumegetMarkersLocations, this.errorgetMarkersLocations);
            },

            consumegetMarkersLocations: function (response) {
                this.rememberBounds = response.data.data.previous_viewport;

                for (var i = 0; i < response.data.data.locations.data.length; i++) {
                    var found = this.markers.find(function(element) { 
                        return element._id == response.data.data.locations.data[i]._id; 
                    }); 
                    if (!found) {
                    this.markers.push({
                        _id: response.data.data.locations.data[i]._id,
                        lat: response.data.data.locations.data[i].location.geometry.coordinates[1],
                        lng: response.data.data.locations.data[i].location.geometry.coordinates[0],
                        respondents_count: response.data.data.locations.data[i].respondents_count,
                        location_id: response.data.data.locations.data[i].location_id
                    });
                }
                    
                }
                if (response.data.data.locations.current_page < response.data.data.locations.last_page) {
                    this.page = response.data.data.locations.current_page + 1;
                    this.getMarkersLocations();
                }
            },

            errorgetMarkersLocations: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                console.log(error);
            },

            clearPlaceInput() {
                 this.$refs.autocomplete.$el.value = '';
                 this.showIcs = false;
            },

            setPlaceBySubmit () {
                const el = this.$refs.autocomplete.$refs.input;
                const ev = new Event('keydown');
                ev.which = 13;
                ev.keyCode = 13;

                return el.dispatchEvent(ev);
            },

            centerChanged(evt) {
                //to use this event add @center_changed="centerChanged" to map tag 
            },
            
            zoomChanged(evt) {
                var boundsMap = this.$refs.campaignMap.$mapObject.getBounds();
                var northEast = boundsMap.getNorthEast();
                var southWest = boundsMap.getSouthWest();
                if ( 
                    typeof boundsMap != 'undefined' &&
                    (
                        this.bounds.south != southWest.lat() ||
                        this.bounds.north != northEast.lat() ||
                        this.bounds.west != southWest.lng() ||
                        this.bounds.east != northEast.lng()
                    )
                ) { 
                    this.page = null;
                    this.bounds.south = southWest.lat();
                    this.bounds.north = northEast.lat();
                    this.bounds.west = southWest.lng();
                    this.bounds.east = northEast.lng();
                    this.giveRememberBounds = true;
                    this.getMarkersLocations();
                    
                }
            },

            boundsChanged(evt) {
                // To use this event again add @bounds_changed="boundsChanged" to map tag
                if ( 
                    typeof evt != 'undefined' &&
                    (
                        typeof this.bounds.south != 'undefined' &&
                        typeof this.bounds.north != 'undefined' &&
                        typeof this.bounds.west != 'undefined' &&
                        typeof this.bounds.east != 'undefined'
                    ) &&
                    (
                        this.bounds.south != evt.Ya.i ||
                        this.bounds.north != evt.Ya.j ||
                        this.bounds.west != evt.Ua.i ||
                        this.bounds.east != evt.Ua.j
                    )
                ) { 
                    this.page = null;
                    this.bounds.south = evt.Ya.i;
                    this.bounds.north = evt.Ya.j;
                    this.bounds.west = evt.Ua.i;
                    this.bounds.east = evt.Ua.j;
                    this.giveRememberBounds = true;
                    this.getMarkersLocations();
                    
                }
            },

            geocodedAddress(latLng, address) {
                if (typeof this.$refs.campaignMap != 'undefined') {
                    this.$gmapApiPromiseLazy().then(() => {
                            var geocoder = new google.maps.Geocoder();
                            geocoder.geocode({'location': latLng}, (results, status) => {
                                if (status === 'OK') {
                                    this.tmpMarker = {
                                        full_address: address ? address : results[0].formatted_address,
                                        lat: latLng.lat(),
                                        lng: latLng.lng()
                                    }
                                    if (this.$store.getters["showTooltipAddMarker"]) {
                                        this.infoPosition = this.getPosition(this.tmpMarker);
                                        this.infoContent = this.firstTooltipContent;
                                        this.infoOpened = true;
                                        this.$store.dispatch('saveShowTooltipAddMarker', {
                                            showTooltipAddMarker: false
                                        });
                                    }
                                    this.$refs.campaignMap.$mapObject.setCenter(latLng);
                                    this.$refs.campaignMap.$mapObject.setZoom(17);
                                    var mapBounds = this.$refs.campaignMap.$mapObject.getBounds();
                                    this.$store.dispatch('saveCurrentLocation', {
                                        currentLocation: this.tmpMarker
                                    });
                                    var northEast = mapBounds.getNorthEast();
                                    var southWest = mapBounds.getSouthWest();

                                    this.bounds.south = southWest.lat();
                                    this.bounds.north = northEast.lat();
                                    this.bounds.west = southWest.lng();
                                    this.bounds.east = northEast.lng();

                                    this.getMarkersLocations();
                                } else {
                                    this.tmpMarker = {
                                        full_address: '',
                                        lat: latLng.lat(),
                                        lng: latLng.lng()
                                    }
                                    this.$refs.campaignMap.$mapObject.setCenter(latLng);
                                    this.$refs.campaignMap.$mapObject.setZoom(17);
                                    this.$store.dispatch('saveCurrentLocation', {
                                        currentLocation: this.tmpMarker
                                    });
                                    if (this.$store.getters["showTooltipAddMarker"]) {
                                        this.infoPosition = this.getPosition(this.tmpMarker);
                                        this.infoContent = this.firstTooltipContent;
                                        this.infoOpened = true;
                                        this.$store.dispatch('saveShowTooltipAddMarker', {
                                            showTooltipAddMarker: false
                                        });
                                    }
                                    var currentMapBounds = this.$refs.campaignMap.$mapObject.getBounds();
                                    var northEast = currentMapBounds.getNorthEast();
                                    var southWest = currentMapBounds.getSouthWest();

                                    this.bounds.south = southWest.lat();
                                    this.bounds.north = northEast.lat();
                                    this.bounds.west = southWest.lng();
                                    this.bounds.east = northEast.lng();
                                    this.getMarkersLocations();
                                }
                            });
                        }
                    );
                }
                
            },

            refreshCampaignMap() {
                if (this.$store.getters["user"] === null) {
                    if (typeof this.$store.getters["token"] == 'undefined') {
                         this.$router.replace({ name: "login"});
                    }
                    this.refreshData();
                }
            },

            setPlace(place) {
                if (typeof place.geometry != 'undefined') {
                    this.page = null;
                    this.rememberBounds = null;
                    this.giveRememberBounds = false;
                    var mapBounds = this.$refs.campaignMap.$mapObject.getBounds();
                    var northEast = mapBounds.getNorthEast();
                    var southWest = mapBounds.getSouthWest();

                    this.bounds.south = southWest.lat();
                    this.bounds.north = northEast.lat();
                    this.bounds.west = southWest.lng();
                    this.bounds.east = northEast.lng();
                    this.markers = [];
                    this.tmpMarker = {
                        full_address: place.formatted_address,
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    };                    
                    this.$store.dispatch('saveCurrentLocation', {
                        currentLocation: this.tmpMarker
                    });
                    this.$store.dispatch('saveShowTooltipAddMarker', {
                        showTooltipAddMarker: false
                    });
                    this.$refs.campaignMap.$mapObject.setCenter(place.geometry.location);
                    this.$refs.campaignMap.$mapObject.setZoom(17);
                    this.extendedAddPin = true;
                    this.infoOpened = false; 
                }
            },

            dragMarker(event) {
                this.geocodedAddress(event.latLng);
                this.extendedAddPin = true;
                this.infoOpened = false;
            },

            addLocation() {
                this.extendedAddPin = false;
                this.infoOpened = false;
                this.goto('add-location', {campaign_id: this.$store.getters["currentCampaign"]._id});
            },

            getPosition: function(marker) {
                return {
                    lat: parseFloat(marker.lat),
                    lng: parseFloat(marker.lng)
                }
            },

            toggleInfo: function(marker, key) {
                this.infoPosition = this.getPosition(marker);
                this.infoContent = '<b>' + marker.name + '</b><br /><br />' + this.$t('campaign_map.location_created_by') + ' <b>' + marker.created_by + '</b> ';
                if (this.infoCurrentKey == key) {
                    this.infoOpened = !this.infoOpened;
                } else {
                    this.infoOpened = true;
                    this.infoCurrentKey = key;
                }
            },
            
            getLocationCorespondents(marker) {
                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                
                axios.post(
                        '/api/v1/campaign/' +  this.$route.params.campaign_id + '/location/' + marker.location_id + '/respondent/get',
                        {},
                        config
                ).then(this.consumegetLocationCorespondents, this.errorgetLocationCorespondents);
            },

            consumegetLocationCorespondents: function (response) {
                let _this = this;
                if (response.data.data.length == 1) {
                    this.$store.dispatch('saveCurrentRespondent', {
                        currentRespondent: response.data.data[0]
                    }).then(()=> {
                        if (response.data.data[0].created_by.id == _this.$store.getters["user"]._id || this.$store.getters["currentCampaign"].owner_id == this.$store.getters["user"]._id) {
                            _this.goto('edit-location', {campaign_id: _this.$store.getters["currentCampaign"]._id, location_id: response.data.data[0].location_id , respondent_id: response.data.data[0]._id});
                        } else {
                            var infoMarker = {
                                name: response.data.data[0].name,
                                lat: response.data.data[0].location.geometry.coordinates[1],
                                lng: response.data.data[0].location.geometry.coordinates[0],
                                created_by: response.data.data[0].created_by.name
                            }
                            _this.toggleInfo(infoMarker, null);
                        }
                        
                    });
                } else {
                    this.goto('locations-list', {campaign_id: this.$store.getters["currentCampaign"]._id, location_id: response.data.data[0].location_id, locations: response.data.data});
                }
            },

            errorgetLocationCorespondents: function (error) {
                console.log(error);
            },

            goToEdit(marker, key) {
                this.getLocationCorespondents(marker);
            },

            geolocate: function(click = false) {
                this.$gmapApiPromiseLazy().then(() => {
                    this.page = null;
                    this.rememberBounds = null;
                    this.giveRememberBounds = false;
                    this.markers = [];
                    navigator.geolocation.getCurrentPosition(position => {
                        var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        this.geocodedAddress(latlng);
                    }, 
                    error => {
                        var latlng = new this.google.maps.LatLng(this.tmpMarker.lat, this.tmpMarker.lng);
                        this.geocodedAddress(latlng);
                        console.log(error);
                    });
                });
                if (click) {
                    this.extendedAddPin = true;
                    this.infoOpened = false;
                }
            }
        },
    };
</script>
